/* FOURNOTHING — LAST CALL / DROP 01
   Estado de la campaña, cuenta regresiva, precios LAST CALL en pantalla, selector de kits
   y sugerencia de kit en el carrito. Los precios los cobra Shopify con descuentos automáticos:
   este archivo solo los muestra. Config en snippets/lc-config.liquid. */
(function () {
  var LC = window.LC;
  if (!LC) return;
  var root = document.documentElement;
  var lastState = null;

  function state() { var n = Date.now(); return n < LC.start ? 'pre' : (n <= LC.end ? 'live' : 'post'); }
  function fmt(n) { return '₲ ' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function left(ms) {
    if (ms < 0) ms = 0;
    var m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    return (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(mm) + 'm';
  }
  function parse(el, sel) { try { return JSON.parse(el.querySelector(sel).textContent); } catch (e) { return null; } }
  LC.fmt = fmt;
  LC.state = state;

  /* ---------- Precios LAST CALL en tarjetas, chips, ficha y barra fija ---------- */
  function applyPrices(st) {
    document.querySelectorAll('[data-lc-handle]').forEach(function (el) {
      var p = LC.prices[el.getAttribute('data-lc-handle')];
      if (!p) return;
      if (el.getAttribute('data-lc-orig') === null) el.setAttribute('data-lc-orig', el.innerHTML);
      if (st === 'live') {
        var reg = parseInt(el.getAttribute('data-lc-regular'), 10) || 0;
        el.innerHTML = '<span class="lc-now">' + fmt(p) + '</span>' + (reg > p ? ' <s class="lc-was">' + fmt(reg) + '</s>' : '');
        el.classList.add('is-lc');
      } else {
        el.innerHTML = el.getAttribute('data-lc-orig');
        el.classList.remove('is-lc');
      }
    });
  }

  /* ---------- Nota LAST CALL en la ficha de remeras y gorras ---------- */
  function pdpNote() {
    var info = document.querySelector('.pdp__info');
    var tag = info && info.querySelector('.pdp__price [data-lc-handle]');
    if (!tag || info.querySelector('.lc-pdp-note')) return;
    var h = tag.getAttribute('data-lc-handle');
    if (!LC.prices[h] || h.indexOf('last-call') === 0) return;
    var isTee = h.indexOf('tee') !== -1;
    var html = '<p><b>LAST CALL</b>: ' + fmt(LC.prices[h]) + ' hasta el domingo 18/10, 23:59.</p>';
    html += isTee
      ? '<p><a href="' + LC.url + '#full-fit">Con una gorra es Full Fit: ' + fmt(LC.prices['last-call-full-fit']) + '</a></p>'
      : '<p><a href="' + LC.url + '#double-cap">Dos gorras: Double Cap a ' + fmt(LC.prices['last-call-double-cap']) + '</a></p>' +
        '<p><a href="' + LC.url + '#full-fit">Con una remera: Full Fit a ' + fmt(LC.prices['last-call-full-fit']) + '</a></p>';
    var note = document.createElement('div');
    note.className = 'lc-pdp-note lc-live';
    note.innerHTML = html;
    var after = info.querySelector('.pdp__sub') || info.querySelector('.pdp__price');
    after.parentNode.insertBefore(note, after.nextSibling);
  }

  function tick() {
    var st = state();
    if (st !== lastState) {
      root.setAttribute('data-lc', st);
      applyPrices(st);
      lastState = st;
    }
    var now = Date.now();
    document.querySelectorAll('[data-lc-countdown]').forEach(function (el) {
      el.textContent = left((el.getAttribute('data-lc-countdown') === 'start' ? LC.start : LC.end) - now);
    });
  }

  /* ---------- Agregar al carrito ---------- */
  function addItem(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function refreshDrawer(open) {
    var p = (typeof updateCartDrawer === 'function') ? updateCartDrawer() : Promise.resolve();
    return Promise.resolve(p).then(function () { if (open && typeof openCartDrawer === 'function') openCartDrawer(); });
  }

  /* ---------- Selector de kits ---------- */
  var SIZES = ['S', 'M', 'L', 'XL'];
  function initKit(form) {
    var kind = form.getAttribute('data-lc-form');
    var list = parse(form, '[data-lc-variants]') || [];
    var stock = parse(form, '[data-lc-stock]') || {};
    var map = {};
    list.forEach(function (v) { map[v.k] = v; });
    var card = form.closest('.lc-kit');
    var note = form.querySelector('[data-lc-note]');
    var sel = {};
    form.querySelectorAll('.lc-chip.is-on').forEach(function (b) { sel[b.getAttribute('data-opt')] = b.getAttribute('data-val'); });
    var submitter = null;

    function btns(opt) { return Array.prototype.slice.call(form.querySelectorAll('.lc-chip[data-opt="' + opt + '"]')); }
    function v(key) { return map[key]; }
    function ok(key) { var x = map[key]; return !!(x && x.a); }
    function ffKey(r, s, g) { return r + '|' + s + '|' + g; }
    function dcKey(a, b) { return [a, b].sort().join('|'); }
    function say(msg, err) { note.textContent = msg || ''; note.classList.toggle('is-error', !!err); }

    function pickFirstEnabled(opt) {
      var b = btns(opt).filter(function (x) { return !x.disabled; })[0];
      sel[opt] = b ? b.getAttribute('data-val') : null;
    }
    function paint() {
      ['1', '2', '3'].forEach(function (opt) {
        btns(opt).forEach(function (b) {
          var on = sel[opt] === b.getAttribute('data-val');
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      card.querySelectorAll('img[data-lc-img]').forEach(function (img) {
        var val = sel[img.getAttribute('data-lc-img')];
        if (!val) return;
        var src = img.getAttribute('data-img-' + val.toLowerCase());
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      });
    }

    function render() {
      if (kind === 'ff') {
        btns('1').forEach(function (b) {
          var r = b.getAttribute('data-val');
          b.disabled = !SIZES.some(function (s) { return ok(ffKey(r, s, 'Trucker')) || ok(ffKey(r, s, 'Washed')); });
        });
        if (!sel['1'] || btns('1').some(function (b) { return b.getAttribute('data-val') === sel['1'] && b.disabled; })) pickFirstEnabled('1');
        btns('3').forEach(function (b) {
          var g = b.getAttribute('data-val');
          b.disabled = !SIZES.some(function (s) { return ok(ffKey(sel['1'], s, g)); });
        });
        if (!sel['3'] || btns('3').some(function (b) { return b.getAttribute('data-val') === sel['3'] && b.disabled; })) pickFirstEnabled('3');
        btns('2').forEach(function (b) { b.disabled = !ok(ffKey(sel['1'], b.getAttribute('data-val'), sel['3'])); });
        if (sel['2'] && !ok(ffKey(sel['1'], sel['2'], sel['3']))) sel['2'] = null;
        var q = sel['2'] ? stock[sel['1'] + '|' + sel['2']] : null;
        say(q === 1 ? 'Queda 1 remera ' + sel['1'] + ' en talle ' + sel['2'] + '.' : '');
      } else {
        btns('1').forEach(function (b) {
          var a = b.getAttribute('data-val');
          b.disabled = !(ok(dcKey(a, 'Trucker')) || ok(dcKey(a, 'Washed')));
        });
        if (!sel['1'] || btns('1').some(function (b) { return b.getAttribute('data-val') === sel['1'] && b.disabled; })) pickFirstEnabled('1');
        btns('2').forEach(function (b) { b.disabled = !ok(dcKey(sel['1'], b.getAttribute('data-val'))); });
        if (!sel['2'] || !ok(dcKey(sel['1'], sel['2']))) pickFirstEnabled('2');
        say('');
      }
      var none = !list.some(function (x) { return x.a; });
      form.querySelectorAll('.lc-ctas.lc-live .lc-btn').forEach(function (b) { b.disabled = none; });
      if (none) say('Este kit se agotó.', true);
      paint();
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('.lc-chip');
      if (b && !b.disabled) {
        sel[b.getAttribute('data-opt')] = b.getAttribute('data-val');
        render();
        return;
      }
      var s = e.target.closest('[data-action]');
      if (s) submitter = s;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state() !== 'live') return;
      var sb = e.submitter || submitter;
      var action = sb && sb.getAttribute('data-action') === 'buy' ? 'buy' : 'add';
      var key = kind === 'ff' ? (sel['2'] ? ffKey(sel['1'], sel['2'], sel['3']) : null) : dcKey(sel['1'], sel['2']);
      if (!key) { say('Elegí un talle para seguir.', true); var first = form.querySelector('.lc-chip--size:not(:disabled)'); if (first) first.focus(); return; }
      var variant = v(key);
      if (!variant || !variant.a) { say('Esa combinación está agotada. Elegí otra.', true); return; }
      var buttons = form.querySelectorAll('.lc-ctas.lc-live .lc-btn');
      buttons.forEach(function (b) { b.disabled = true; });
      var main = form.querySelector('[data-action="' + action + '"]');
      var label = main.textContent;
      main.textContent = action === 'buy' ? 'Yendo a pagar…' : 'Agregando…';
      addItem(variant.id).then(function (res) {
        if (!res.ok) {
          say((res.j && res.j.description) || 'No pudimos agregarlo. Probá de nuevo.', true);
          main.textContent = label;
          buttons.forEach(function (b) { b.disabled = false; });
          return;
        }
        if (action === 'buy') { window.location.href = '/checkout'; return; }
        say('Listo, quedó en tu carrito.');
        main.textContent = 'Agregado';
        refreshDrawer(true).then(function () {
          setTimeout(function () { main.textContent = label; buttons.forEach(function (b) { b.disabled = false; }); }, 1400);
        });
      }).catch(function () {
        say('No pudimos agregarlo. Revisá tu conexión y probá de nuevo.', true);
        main.textContent = label;
        buttons.forEach(function (b) { b.disabled = false; });
      });
    });

    render();
  }

  /* ---------- Carrito: si arman el combo con piezas sueltas, ofrecer el kit ---------- */
  LC.renderNudge = function (cart) {
    var box = document.getElementById('lc-nudge');
    if (!box) return;
    box.innerHTML = '';
    if (state() !== 'live' || !cart || !cart.items) return;
    var tees = [], caps = [], capUnits = 0;
    cart.items.forEach(function (it) {
      var id = String(it.variant_id);
      if (LC.tees[id]) tees.push(it);
      else if (LC.caps[id]) { caps.push(it); capUnits += it.quantity; }
    });
    var offer = null;
    if (tees.length && caps.length) {
      var t = tees[0], c = caps[0];
      var kitId = LC.fullFit[LC.tees[String(t.variant_id)] + '|' + LC.caps[String(c.variant_id)]];
      var save = (t.final_price + c.final_price) / 100 - LC.prices['last-call-full-fit'];
      if (kitId && save > 0) offer = { id: kitId, use: [[t, 1], [c, 1]], name: 'Full Fit', price: LC.prices['last-call-full-fit'], save: save, txt: 'Tenés una remera y una gorra sueltas.' };
    } else if (capUnits >= 2) {
      var a = caps[0], b = a.quantity >= 2 ? a : caps[1];
      var key = [LC.caps[String(a.variant_id)], LC.caps[String(b.variant_id)]].sort().join('|');
      var save2 = (a.final_price + b.final_price) / 100 - LC.prices['last-call-double-cap'];
      var use = a === b ? [[a, 2]] : [[a, 1], [b, 1]];
      if (LC.doubleCap[key] && save2 > 0) offer = { id: LC.doubleCap[key], use: use, name: 'Double Cap', price: LC.prices['last-call-double-cap'], save: save2, txt: 'Tenés dos gorras sueltas.' };
    }
    if (!offer) return;
    box.innerHTML = '<div class="lc-nudge"><p>' + offer.txt + ' Como ' + offer.name + ' pagás ' + fmt(offer.price) + ' y ahorrás ' + fmt(offer.save) + '.</p><button type="button">Pasar a ' + offer.name + '</button></div>';
    var btn = box.querySelector('button');
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Armando el kit…';
      addItem(offer.id).then(function (res) {
        if (!res.ok) { btn.textContent = 'Ese kit ya no tiene stock'; return null; }
        var chain = Promise.resolve();
        offer.use.forEach(function (u) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: u[0].key, quantity: Math.max(0, u[0].quantity - u[1]) })
            });
          });
        });
        return chain.then(function () { return refreshDrawer(false); });
      }).catch(function () { btn.disabled = false; btn.textContent = 'Pasar a ' + offer.name; });
    });
  };

  function boot() {
    tick();
    pdpNote();
    document.querySelectorAll('form[data-lc-form]').forEach(initKit);
    setInterval(tick, 20000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
